<template>
  <v-app>
    <div class="animated fadeIn">

      <ddoWaiting :value="loading" :message="$t('texts.loading')"/>

      <ddoClientList :loading="loading" :level="levels[0]" 
          :columns="levels[0].columns" :options="levels[0].options" :callbacks="levels[0].callbacks"
          :customSlotNames="levels[0].customSlotNames"
          @loading="refresh_loading"
          @row="refresh_row"
          @childKey="refresh_childKey"
          @errors="refresh_errors"
          >

          <template slot="searchengine" slot-scope="props">
            <p>
              <b-radio-group id="net_public" v-model="levels[0].searchValues.net_public" label="Public/Privé" @change="filter_rows(0)">
                <b-radio value="">Tous</b-radio>
                <b-radio value="true">PUBLIC</b-radio>
                <b-radio value="false">PRIVE</b-radio>
              </b-radio-group>
              <b-radio-group id="net_ipnature" v-model="levels[0].searchValues.net_ipnature" label="Nature :" @change="filter_rows(0)">
                <b-radio value="">Tous</b-radio>
                <b-radio value="4">IPv4</b-radio>
                <b-radio value="6">IPv6</b-radio>
              </b-radio-group>
             </p>
          </template>

          <template slot="net_ipv4" slot-scope="props">
            <b-checkbox disabled v-model="props.row.net_ipv4">{{ $t('texts.net_ipv4') }}</b-checkbox>
            <b-checkbox disabled v-model="props.row.net_ipv6">{{ $t('texts.net_ipv6') }}</b-checkbox>
            <b-checkbox disabled v-model="props.row.net_public">{{ $t('texts.net_public') }}</b-checkbox>
            <b-checkbox disabled v-model="props.row.net_deployable">{{ $t('texts.net_deployable') }}</b-checkbox>
          </template>

          <template slot="net_ipa_affectation_percent" slot-scope="props">
            <v-progress-circular
              :rotate="-90"
              :size="100"
              :width="15"
              :value="props.row.net_ipa_affectation_percent"
              color="teal"
            >
              <strong>{{ props.row.net_ipa_live_count }}</strong>/{{ props.row._count }}
            </v-progress-circular>
          </template>

          <template v-slot:dialogform="{ row, level }">
            <CardUpdatableNetwork ref="myCardUpdatable" :row="levels[0].row" :depth="levels[0].level" :level="levels[0]"
              @errors="refresh_errors"
            />
          </template>

          <template v-slot:child_row="{ props }">
            <ddoClientListIPA :loading="loading" :level="levels[1]" :childKey="levels[1].childKey"
              :columns="levels[1].columns" :options="levels[1].options" :callbacks="levels[1].callbacks" :nbCols="childNbCols"
              @childKey="refresh_childKey"
              @row="refresh_row"
            >

              <template v-slot:superheader="slotProps">
                <h3>{{ $api._format($t('subtitles.ipa'),slotProps.parentToggledRow['net_code']) }}</h3>
              </template>

            </ddoClientListIPA>
          </template>

        <template v-slot:superheader="{ errors }">
          <h2>{{ $t('titles.net') }}</h2>
        </template>

      </ddoClientList>

    </div>
  </v-app>
</template>

<script>
import Vue from 'vue';
import i18n from '@/plugins/i18n.js';
import BasicList from '@/views/BasicList.vue';
import { Event } from '@/components/ddoClientList.vue';

import CardUpdatableNetwork from '@/components/partials/CardUpdatableNetwork.vue';
import ddoClientList from '@/components/ddoClientList.vue';
import ddoClientListIPA from '@/components/ddoClientListIPA.vue';

Vue.use(ddoClientListIPA);

let initial_row = {}

export default {
  name: 'network',
  mixins: [BasicList],
  components: {
    CardUpdatableNetwork,
    ddoClientList,
    ddoClientListIPA
  },
  data: () => {
    return {
      _this: null,
      loading: false,

      /* 
       * LEVEL 1 : all for ddoClientList : columns, options, callbacks
       */
      levels: [

      {
        api_code: 'network',
        api_prefix: 'net',
        row: {},
        level: 0,
        errors: [],
        columns: [ '_actions', 'net_pk', 'net_code', 'net_ipv4', 'net_desc', 'net_cidr', 'vla_id', 'net_ipa_affectation_percent', '_update'],
        customSlotNames: ['net_ipv4','net_ipa_affectation_percent'],
        searchValues: {
          net_public: null,
          net_ipnature: '4',
        },
        options: {
          showChildRowToggler: false,
          withChild: true,
          hiddenColumns: [],
          headings: {
            _pk: i18n.t('headers.actions'),
            _child: i18n.t('headers.actions'),
            net_pk: '#',
            net_ipv4: i18n.t('headers.flags'),
            net_code: i18n.t('headers.code'),
            net_desc: i18n.t('headers.description'),
            net_cidr: i18n.t('headers.cidr'),
            vla_id: i18n.t('headers.vla_id'),
            net_ipa_affectation_percent: i18n.t('headers.ipa_affectation'),
            _update: i18n.t('headers.updated_on')
          },
          texts: {
          },
          uniqueKey: 'net_pk',
          sortable: ['net_code','_update'],
          filterable: false,
          sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
          columnsDropdown: false,
          pagination: {
            chunk: 5,
            edge: false,
            nav: 'scroll'
          },
          columnsDisplay: {
            _update: 'desktop',
            net_desc: 'desktop',
            net_pk: 'desktop',
          },
          customFilters: [{
            name: 'search',
            callback: function (row, query) {
              let $ret = true;
              console.log('callback, query='+JSON.stringify(query));
              if ( $ret && query.net_public!='' ) {
                if ( query.net_public=="true" && !row.net_public ) { $ret = false; }
                if ( query.net_public=="false" && row.net_public ) { $ret = false; }
              }
              if ( $ret && query.net_ipnature!='' ) {
                if ( query.net_ipnature=="4" && !row.net_ipv4 ) { $ret = false; }
                if ( query.net_ipnature=="6" && !row.net_ipv6 ) { $ret = false; }
              }
              return $ret;
            }
          }],
        },
        callbacks: {
        },
        dialogOptions: {
          codeRules : [
            (v) => !!v || i18n.t('texts._required')
          ]
        },
        dialogValues: {
          headers: {
            create: i18n.t('texts.net_create_title'),
            update: i18n.t('texts.net_update_title'),
            delete: i18n.t('texts.net_delete_title'),
          },
          dialogShow: false,
          form_disabled: false,
          form_close: true,
          form_create: false,
          form_update: false,
          form_delete: false,
          disable_create: false,
          disable_update: false,
          disable_delete: false,
          header_value_function: function(row) { return row['net_code']; }
       },
      },

       {
        api_code: 'ipaddress',
        api_prefix: 'ipa',
        row: {},
        level: 1,
        errors: [],
        callbacks: {
        },
        dialogOptions: {
          codeRules : [
            (v) => !!v || i18n.t('texts._required')
          ]
        },
        dialogValues: {
          header_value_function: function(row) { return row['net_code']; }
        },
      },

      ],

      childNbCols: 16,

      useVuex: false,
      theme: 'bootstrap4',
      template: 'default',
    }
  },

  created() {
    this._this = this;
    this.levels[0].callbacks.configure_form = this.configure_form;
    this.levels[0].callbacks.prepare_create = this.prepare_create;    
    this.levels[0].callbacks.prepare_update = this.prepare_update;    
    this.levels[0].callbacks.prepare_delete = this.prepare_delete;    
    this.levels[0].callbacks.show_dialog    = this.show_dialog;
    this.levels[0].callbacks.refresh_errors = this.refresh_errors;

    this.levels[1].callbacks.refresh_rows = this.refresh_rows_l2;

  },

  methods: {

    refresh_row(level,row) {
      this.levels[level].row = row;
    },

    async refresh_rows_l2(key) {
      this.loading = true;
      let { errorinfos, api_response } = await this.$api.getRows(this.$router,this.levels[0].api_code+'/'+key+'/addresses');
      this.loading = false;
      return { errorinfos, api_response }
    },

    prepare_create(parentKey=null) {
       this.$refs.myCardUpdatable.VLAoptions.disabled = false;
       this.$refs.myCardUpdatable.VLAoptions.initial  = null;
    },

    async prepare_update(parentKey=null) {
       this.$refs.myCardUpdatable.VLAoptions.disabled = false;
       this.$refs.myCardUpdatable.VLAoptions.initial  = this.levels[0].row.vla_pk;
    },

    async prepare_delete(parentKey=null) {
       this.$refs.myCardUpdatable.VLAoptions.disabled = true;
       this.$refs.myCardUpdatable.VLAoptions.initial  = this.levels[0].row.vla_pk;
    },

    filter_rows(level) {
      Event.$emit('vue-tables.filter::search', this.levels[level].searchValues);
    },
  }
}
</script>